/**
 * Public Help Scout Docs site (Sam, Oct 4 2026). 83 articles in 7 categories.
 * Plain outbound link (new tab) — not embedded, so CSP is unaffected.
 */
export const HELP_CENTER_URL = 'https://sweet-listeners.helpscoutdocs.com';
export const HELP_CENTER_LINK_PROPS = {
  href: HELP_CENTER_URL,
  target: '_blank',
  rel: 'noopener noreferrer',
};
